import { Inbox } from '@crehana/compass.icons.outline/v2/inbox';

import { useHomeTranslations } from '../../../hooks/use-home-translations';

export function EmptyState() {
  const { t } = useHomeTranslations();

  return (
    <div className="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-cds-gap-content-elements">
      <span className="tw-rounded-full tw-cds-w-56 tw-cds-h-56 tw-flex tw-items-center tw-justify-center tw-cds-bg-subtle-01">
        <Inbox className="tw-text-[var(--cds-icon-color-subtle)]" size={24} />
      </span>
      <div>
        <p className="tw-cds-font-subtitle-01 tw-text-center">
          {t('PAYROLL_EMPTY_TITLE')}
        </p>
        <p className="tw-cds-font-body-01 tw-text-center">
          {t('PAYROLL_EMPTY_DESCRIPTION')}
        </p>
      </div>
    </div>
  );
}
